// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CustomerProjectPagingResultModel from '../../model/customer-project-paging-result-model';
import CustomerProjectPagingResultDTO from '../dto/customer-project-paging-result-dto';
import dtoSchema from '../schemas/customer-project-paging-result-schema';
import CustomerProjectModel from '../../model/customer-project-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class CustomerProjectPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CustomerProjectPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CustomerProjectModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: CustomerProjectModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<CustomerProjectPagingResultDTO>): CustomerProjectPagingResultModel;
  static toModel(dto: DeepPartial<CustomerProjectPagingResultDTO> | undefined | null): CustomerProjectPagingResultModel | undefined;
  static toModel(dto: DeepPartial<CustomerProjectPagingResultDTO> | undefined | null): CustomerProjectPagingResultModel | undefined {
    return dto ? new CustomerProjectPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CustomerProjectPagingResultModel> | CustomerProjectPagingResultModel): CustomerProjectPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as CustomerProjectPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CustomerProjectPagingResultModel, can not map to CustomerProjectPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
